import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { useState as E, useRef as M, useCallback as F } from "react";
import e from "./style.module.less.js";
import L from "react-markdown";
import O from "rehype-raw";
import { FilePreview as W } from "./file-preview/index.js";
var j = /* @__PURE__ */ ((a) => (a.Receiver = "Receiver", a.Sender = "Sender", a))(j || {});
const H = (a) => /* @__PURE__ */ r("a", { href: a.href, target: "_blank", rel: "noreferrer", children: a.children }), I = (a) => {
  const {
    externalBody: o,
    messageBody: i,
    sender: v,
    avatarLeft: h,
    avatarRight: p,
    avatarClassName: u,
    type: s,
    className: $,
    wrapperClassName: y,
    timestamp: g,
    timestampClassName: C,
    files: c,
    fileClassName: w,
    filePreviewClassName: R,
    systemFormMessage: x,
    senderOverlayClassName: B,
    receiverOverlayClassName: T,
    fixedPositioning: k,
    getTranslation: P,
    ...S
  } = a, [l, t] = E(!1), n = M(null), f = F(() => {
    t && (l ? t(!1) : (n.current && clearTimeout(n.current), n.current = setTimeout(() => {
      t(!1), n.current = null;
    }, 2e3), t(!0)));
  }, [l, t]), N = i && typeof i == "string" ? /* @__PURE__ */ r(
    L,
    {
      rehypePlugins: [O],
      components: { a: H },
      children: i
    }
  ) : i;
  return /* @__PURE__ */ d(
    "div",
    {
      className: `${e.messageWrapper} ${s === "Sender" ? e.right : e.left} ${y ?? ""}`,
      children: [
        h ? /* @__PURE__ */ r("div", { className: `${u ?? ""}`, children: h }) : null,
        /* @__PURE__ */ d("div", { className: e.relativeWrapper, children: [
          /* @__PURE__ */ d("div", { className: `${e.relativeContainer} ${o ? e.withExternalBody : e.noExternalBody}
          ${l ? e.show : e.hide}
          `, children: [
            v ? /* @__PURE__ */ r("div", { className: `${e.senderContainer}
            ${s === "Receiver" ? e.left : e.right}`, children: v }) : null,
            N ? /* @__PURE__ */ r(
              "div",
              {
                className: `${e.message} ${x ? e.systemFormMessage : s === "Sender" ? e.messageRight : e.messageLeft} ${$ ?? ""}`,
                ...S,
                onClick: f,
                children: N
              }
            ) : null,
            c == null ? void 0 : c.map((m, b) => /* @__PURE__ */ r(
              W,
              {
                file: m,
                receiver: s === "Receiver",
                className: w,
                previewClassName: R,
                toggleTimestamp: f,
                senderOverlayClassName: B,
                receiverOverlayClassName: T,
                fixedPositioning: k,
                getTranslation: P
              },
              (m == null ? void 0 : m.id) ?? b
            )),
            g ? /* @__PURE__ */ r("div", { className: `${e.timestampContainer}
              ${l ? e.show : e.hide}`, children: /* @__PURE__ */ r(
              "div",
              {
                className: `${e.timestamp} ${C ?? ""}
                ${s === "Receiver" ? e.left : e.right}
                ${o ? e.withExternalBody : e.noExternalBody}`,
                children: g
              }
            ) }) : null
          ] }),
          o
        ] }),
        p ? /* @__PURE__ */ r("div", { className: `${u ?? ""}`, children: p }) : null
      ]
    }
  );
};
export {
  j as ChatMessageType,
  I as ChatMessageWrapper
};
